export const appInitializerMessages = {
  en: {
    error: 'Failed to load initial app data.',
  },
};
